<template>
  <div class="way">
    <!-- <div class="pay_way_title">
      {{ $t("message.DataRegistration.Taxi.pay_way") }}
    </div>
    <FormBox :title="$t('message.DataRegistration.Taxi.pay_way1')">
      <div class="way_div">
        <GradientBtn :white="false" @click="webPay">{{
          $t("message.DataRegistration.Taxi.pay_way1_btn")
        }}</GradientBtn>
      </div>
    </FormBox> -->

    <FormBox :title="$t('message.DataRegistration.Taxi.pay_way2')">
      <div class="way_div">
        <div data-clipboard-action="copy" class="way_url">{{ url }}</div>
        <GradientBtn
          white
          v-clipboard:copy="url"
          v-clipboard:success="onCopy"
          v-clipboard:error="onError"
          >{{ $t("message.DataRegistration.Taxi.copy_link") }}</GradientBtn
        >
      </div>
    </FormBox>
    <el-dialog
      :title="$t('message.tips')"
      :visible.sync="showDialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="300px"
      class="dialog_center_type trems_dialog"
      :before-close="handleClose"
    >
      <div class="paid_tips">
        {{ $t("message.DataRegistration.Taxi.paid_tips") }}
      </div>
      <div class="way_tips_btn">
        <GradientBtn white @click="paySuccess">{{
          $t("message.pay_success")
        }}</GradientBtn>
      </div>
      <!-- <div class="way_tips_btn">
        <GradientBtn white @click="back">{{ $t("message.back") }}</GradientBtn>
      </div> -->
    </el-dialog>
  </div>
</template>

<script>
import FormBox from "../components/FormBox";
import GradientBtn from "../../../../components/GradientBtn";
export default {
  components: { FormBox, GradientBtn },
  data() {
    return {
      url: "",
      showDialog: false,
    };
  },
  methods: {
    webPay() {
      if (this.url) {
        window.location.href = this.url;
      }
    },
    copy() {
      console.log("ok");
      //   let clipboard = new Clipboard(".way_url");
      //   clipboard.on("success", (e) => {
      //     this.$message({
      //       message: "复制成功",
      //       showClose: true,
      //       type: "success",
      //     });
      //     // 释放内存
      //     clipboard.destroy();
      //   });
      //   clipboard.on("error", (e) => {
      //     this.$message({ message: "复制失败,", showClose: true, type: "error" });
      //     clipboard.destroy();
      //   });
    },
    onCopy() {
      this.showDialog = true;
    },

    // 复制失败
    onError() {
      this.$message({
        message: this.$t("message.copy_failed"),
        type: "error",
      });
    },
    paySuccess() {
      let applicationNo = this.$route.query.applicationNo;
      this.$router.push({
        path: "/taxiPaymentResult",
        query: {
          way: true,
          applicationNo,
        },
      });
    },
    back() {
      this.showDialog = false;
    },
  },
  created() {
    var curWwwPath = window.document.location.href;
    var pathName = window.document.location.pathname;
    var pos = curWwwPath.indexOf(pathName);
    var host = curWwwPath.substring(0, pos);
    this.url = host + this.$route.query.url;

    // 回到頂部
    window.scrollTo(0, 0);
  },
};
</script>

<style lang="scss" scoped>
.way {
  min-height: 400px;
}
.way_div {
  text-align: center;
  width: 90%;
  margin-top: 50px;
  margin-bottom: 20px;
  margin-left: auto;
  margin-right: auto;
}
.way_url {
  margin: 20px auto 40px auto;
  font-size: 16px;
  max-width: 500px;
  word-break: break-all;
}
.way_tips_btn {
  text-align: center;
  margin-top: 20px;
}
/deep/.el-dialog {
  margin-top: 25vh !important;
}
.pay_way_title {
  text-align: center;
  color: #f59a23;
  border: 1px solid #facd91;
  max-width: 220px;
  padding: 8px;
  border-radius: 10px;
  margin: 30px auto 10px auto;
}
.paid_tips {
  color: #333;
  font-size: 16px;
  width: 220px;
  margin: auto;
  margin: 0 auto 30px auto;
}
/deep/.dialog_center_type .el-dialog__body {
  padding: 0px;
  padding-bottom: 30px;
}
</style>
